import ItodoImage from "../../../elements/itodo-img";
import { NavLink } from "react-router-dom";
import { teamUnits } from "../../../../globals/neuron-content";

function SectionTeam1() {
  return (
    <div className="section-full p-t110 p-b80 sx-bg-light sx-ourteam-outer ">
      <div className="container">
        <div className="section-head center">
          <div className="sx-head-s-title">Specialized Capability</div>
          <div className="sx-head-l-title"><h2 className="sx-title">Protection and Operations Teams</h2></div>
        </div>
        <div className="section-content">
          <div className="row sx-our-team-section">
            {teamUnits.map((unit) => (
              <div key={unit.name} className="col-lg-3 col-md-6 col-sm-6">
                <div className="our-team-2">
                  <div className="profile-image">
                    <ItodoImage src={unit.image} alt={unit.name} />                  </div>
                  <div className="figcaption">
                    <p>{unit.role}</p>
                    <h4 className="sx-title"><NavLink to="/team">{unit.name}</NavLink></h4>
                  </div>
                </div>
              </div>
            ))}
          </div>
        </div>
      </div>
    </div>
  );
}

export default SectionTeam1;
